$(document).ready(function () {

    // Get pricing switch
    var pricingSwitch = $("#pricingToggle");
    // Check pricing switch exists before running code
    if(pricingSwitch.length){
        if (locale === 'us') {
            //Get US plans
            dataPlan = $('.js-us-price-data');
            starterPlan = $('.js-us-price-starter');
            proPlan = $('.js-us-price-pro');
            enterprisePlan = $('.js-us-price-enterprise');
            intelligencePlan = $('.js-us-price-intelligence-pack');

        } else {
            // Get UK plans
            dataPlan = $('.js-price-data');
            starterPlan = $('.js-price-starter');
            proPlan = $('.js-price-pro');
            enterprisePlan = $('.js-price-enterprise');
            intelligencePlan = $('.js-price-intelligence-pack');
        }

        function pricingSwitchIs() {
            // return true if switch has class active
            if (pricingSwitch.hasClass('active')) {
                // annual
                return true;
            } else {
                // monthly
                return false;
            }
        }

        function getTenPercent(additionalEmailCredits) {
            var tenPercent = Math.round((10/ 100) * additionalEmailCredits);
            return addTenPercent = additionalEmailCredits + tenPercent;
        }

        pricingSwitch.click(function () {

            // Get the monthly plan price from data attribute on each plan
            var monthlyDataPlan = parseInt(dataPlan.data('monthly-total'));
            var monthlyStarterPlan = parseInt(starterPlan.data('monthly-total'));
            var monthlyProPlan = parseInt(proPlan.data('monthly-total'));
            var monthlyEnterprisePlan = parseInt(enterprisePlan.data('monthly-total'));

            // Get the annual plan price from data attribute on each plan
            var annualDataPlan = dataPlan.data('annual-total');
            var annualStarterPlan = starterPlan.data('annual-total');
            var annualProPlan = proPlan.data('annual-total');
            var annualEnterprisePlan = enterprisePlan.data('annual-total');

            // Get input value for each plan
            var starterInput = ($('#starterInput').val());
            var proInput = ($('#proInput').val());
            var enterpriseInput = ($('#enterpriseInput').val());

            // Get additional emails user adds in input
            var getAdditionalEmailsStarterPlan = starterInput - 5000;
            var getAdditionalEmailsProPlan = proInput - 20000;
            var getAdditionalEmailsEntPlan = enterpriseInput - 50000;

            // Get value of additional emails from look up table
            var lookupStarterPlan = pricingLookupTable[getAdditionalEmailsStarterPlan];
            var lookupProPlan = pricingLookupTable[getAdditionalEmailsProPlan];
            var lookupEntPlan = pricingLookupTable[getAdditionalEmailsEntPlan];


            if (pricingSwitchIs('true')) {
                // Pay annual plans

                dataPlan.html(annualDataPlan);

                var annualCalcPriceStarter = (annualStarterPlan + lookupStarterPlan);
                starterPlan.html(annualCalcPriceStarter);

                var annualCalcPricePro = (annualProPlan + lookupProPlan);
                proPlan.html(annualCalcPricePro);

                var annualCalcPriceEnt = (annualEnterprisePlan + lookupEntPlan);
                enterprisePlan.html(annualCalcPriceEnt);

            } else {
                // Pay monthly plans (more expensive option)

                dataPlan.html(monthlyDataPlan);

                //Calculate 10% of lookup table value and add on to monthly plan price
                var addTenPercentStarter = getTenPercent(lookupStarterPlan);
                var monthlyCalcPriceStarter = (monthlyStarterPlan + addTenPercentStarter);
                starterPlan.html(monthlyCalcPriceStarter);

                //Calculate 10% of lookup table value and add on to monthly plan price
                var addTenPercentPro = getTenPercent(lookupProPlan);
                var monthlyCalcPricePro = (monthlyProPlan + addTenPercentPro);
                proPlan.html(monthlyCalcPricePro);

                //Calculate 10% of lookup table value and add on to monthly plan price
                var addTenPercentEnt = getTenPercent(lookupEntPlan);
                var monthlyCalcPriceEnt = (monthlyEnterprisePlan + addTenPercentEnt);
                enterprisePlan.html(monthlyCalcPriceEnt);
            }
        });
    }
});






